import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { patchEndActivityLog } from '../services/patchEndActivityLog.service';

/**
 * Marks an activity as ended: stamps a server-side `endedAt` on the activity-log
 * row identified by `sk` (the handle returned when the log was created), so the
 * UI can show how long the activity lasted. Generic across action types —
 * VIEW_IMAGE (image preview closed / paged away) today, other activities later.
 * Fire-and-forget best-effort: failures land in the `rejected` action and the
 * log simply stays open-ended.
 */
export const logActivityEnded = createAsyncThunk(
  'activityLog/logActivityEnded',
  async ({ projectId, sk }, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    return patchEndActivityLog({ projectId, sk, activeEmployerInfo });
  }
);
